/**
 * @generated SignedSource<<e7c1c645ef808764af77e4db050a61ff>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BuyerProductTile_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ProductBaseTile_viewer">;
  readonly " $fragmentType": "BuyerProductTile_viewer";
};
export type BuyerProductTile_viewer$key = {
  readonly " $data"?: BuyerProductTile_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"BuyerProductTile_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuyerProductTile_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductBaseTile_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "884bf941e2347cb3863b842e12947408";

export default node;
